import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import { Injectable } from '@angular/core';

@Injectable()
export class CalendarFormatter extends CalendarDateFormatter {
  public override monthViewColumnHeader({
    date,
    locale,
  }: {
    date: Date;
    locale: string;
  }): string {
    const width = window.innerWidth;

    let weekdayFormat: 'narrow' | 'short' | 'long' = 'short';

    if (width < 400) {
      weekdayFormat = 'narrow';
    } else if (width < 768) {
      weekdayFormat = 'short';
    } else {
      weekdayFormat = 'long';
    }

    const intlWeekday = new Intl.DateTimeFormat(locale, {
      weekday: weekdayFormat,
    }).format(date);

    const normalized = intlWeekday
      .toLowerCase()
      .replace('-feira', '')
      .replace('.', '')
      .trim();

    return normalized || intlWeekday;
  }
}
